import { Proposal } from '../../../../domain'
import { useQuoteData } from '../../quote'

export const useProposalData = (proposal: Proposal) =>
  useQuoteData(proposal.quote, proposal.startAt)
